import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'

// Vuetify
import 'vuetify/styles'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import { aliases, mdi } from 'vuetify/iconsets/mdi'
import '@mdi/font/css/materialdesignicons.css'

// Tema personalizado QuarnX
const temaQuarnX = {
  dark: true,
  colors: {
    primary: '#7E57C2',    // Roxo QuarnX
    secondary: '#03A9F4',  // Azul Claro
    accent: '#FF4081',     // Rosa Accent
    success: '#4CAF50',    // Verde
    warning: '#FFC107',    // Amarelo
    error: '#FF5252',      // Vermelho
    info: '#2196F3',       // Azul Info
    background: '#121212', // Fundo escuro
    surface: '#1E1E1E',    // Superfície
  },
}

const vuetify = createVuetify({
  components,
  directives,
  icons: {
    defaultSet: 'mdi',
    aliases,
    sets: {
      mdi,
    },
  },
  theme: {
    defaultTheme: 'temaQuarnX',
    themes: {
      temaQuarnX,
    },
  },
})

// Criação da aplicação
const app = createApp(App)

// Registro de componentes globais e plugins
app.use(createPinia())
app.use(router)
app.use(vuetify)

// Global mixin: provides reactive i18n `t()` to ALL components
// `$locale` is a computed that tracks the Pinia store reactively
// `t(key)` reads from `$locale` so Vue re-renders on locale change
import { useLocaleStore } from './stores/locale'

app.mixin({
  computed: {
    coin() {
      return window.__QUARNX_COIN__ || 'tKinX'
    },
    $locale() {
      // This computed is reactive — Vue tracks store.current
      return useLocaleStore().current
    }
  },
  methods: {
    t(key) {
      // Access this.$locale to create reactive dependency
      // eslint-disable-next-line no-unused-expressions
      this.$locale
      return useLocaleStore().t(key)
    }
  }
})

// Configuração de interceptadores globais
app.config.errorHandler = (err, vm, info) => {
  console.error('Erro na aplicação:', err, info)
}

// Montagem da aplicação no elemento raiz
app.mount('#app')
